import { Navigate, Outlet, RouteProps } from "react-router-dom";

interface IPrivateRoute {
  user: any;
  children?: any;
  token: any;
  redirectPath?: string;
  isAllowedByRole: boolean;
}

const PrivateRoute = ({
  children,
  redirectPath = "/",
  isAllowedByRole,
}: IPrivateRoute) => {
  if (!isAllowedByRole) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};

export default PrivateRoute;
